export default {
  ASSET:{
    ASSET:{
      READ:'read_assets',
      REGISTER:'add_assets',
      DELETE:'delete_assets',
      UPDATE:'change_assets',
    },
    TRACKING:{
      READ:'read_tracking',
      REGISTER:'add_tracking',
      DELETE:'delete_tracking',
      UPDATE:'change_tracking',
    },
    IMAGE:{
      READ:'read_photos',
      REGISTER:'add_photos',
      DELETE:'delete_photos',
      UPDATE:'change_photos',
    }
  },
  LOCATION:{
    LOCATION:{
      READ:'read_locations',
      REGISTER:'add_locations',
      DELETE:'delete_locations',
      UPDATE:'change_locations',
    },
    SITE:{
      READ:'read_sites',
      REGISTER:'add_sites',
      DELETE:'delete_sites',
      UPDATE:'change_sites',
    },
    CITY_COVERAGE:{
      READ:'read_citycoverage',
      REGISTER:'add_citycoverage',
      DELETE:'delete_citycoverage',
    },
  },
  MASTER:{
    ASSET_STATUS:{
      READ:'read_assetsstatus',
      REGISTER:'add_assetsstatus',
      DELETE:'delete_assetsstatus',
      UPDATE:'change_assetsstatus',
    },
    ASSET_TYPE:{
      READ:'read_assettypes',
      REGISTER:'add_assettypes',
      DELETE:'delete_assettypes',
      UPDATE:'change_assettypes',
    },
    BUSINESS_MODEL:{
      READ:'read_businessmodels',
      REGISTER:'add_businessmodels',
      DELETE:'delete_businessmodels',
      UPDATE:'change_businessmodels',
    },
    DEPARTEMENT:{
      READ:'read_departements',
      REGISTER:'add_departements',
      DELETE:'delete_departements',
      UPDATE:'change_departements',
    },
    SITE_STATUS:{
      READ:'read_sitesstatus',
      REGISTER:'add_sitesstatus',
      DELETE:'delete_sitesstatus',
      UPDATE:'change_sitesstatus',
    },
    SITE_TYPE:{
      READ:'read_sitetypes',
      REGISTER:'add_sitetypes',
      DELETE:'delete_sitetypes',
      UPDATE:'change_sitetypes',
    },
    CONTACT:{
      READ:'read_contacts',
      REGISTER:'add_contacts',
      DELETE:'delete_contacts',
      UPDATE:'change_contacts',
    },
    TENANT_SETTING:{
      READ:'read_tenants',
      REGISTER:'add_tenants',
      DELETE:'delete_tenants',
      UPDATE:'change_tenants',
    },
    MAINTENANCE_TYPE:{
      READ:'read_maintenances',
      REGISTER:'add_maintenances',
      DELETE:'delete_maintenances',
      UPDATE:'change_maintenances',
    }
  },
  USER:{
    ROLE:{
      READ:'read_roles',
      REGISTER:'add_roles',
      DELETE:'delete_roles',
      UPDATE:'change_roles',
    },
    USER:{
      READ:'read_users',
      REGISTER:'add_users',
      DELETE:'delete_users',
      UPDATE:'change_users',
    },
  }
}



// WEBPACK FOOTER //
// ./src/App/config/permission.js